interface MediaItem {
  altText?: string
  url?: string
  id?: number
}

interface PropertyValue {
  mediaItems?: MediaItem[]
}

interface DataProperty {
  propertyName: string | null
  propertyValue: PropertyValue | null
}

interface Data {
  properties?: DataProperty[]
}

export function extractAlt(data: Data | any, propertyName: string): string {
  if (!data || !propertyName) {
    return ""
  }

  const property = data.properties?.find(
    (prop: DataProperty) => prop.propertyName === propertyName,
  )

  return property?.propertyValue?.mediaItems?.[0]?.altText || ""
}
